module.exports = __webpack_public_path__ + "static/media/menu-icon-special.b4669edc.png";